// RouteSpinner — fallback для <Suspense> при ленивой загрузке route-чанков.
// Рендерится в контентной области (внутри Layout Outlet), поэтому не full-screen:
// сайдбар и топбар остаются на месте, пока грузится чанк страницы.
// Стилистика спиннера — та же, что в RequireAuth (см. §11 07-frontend-vite.md).
export function RouteSpinner(): JSX.Element {
  return (
    <div className="flex min-h-[50vh] items-center justify-center" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-3">
        <div
          className="h-8 w-8 animate-spin rounded-full border-2 border-divider-gray border-t-blueprint-blue"
          aria-hidden="true"
        />
        <span className="text-sm text-muted-foreground">Загрузка…</span>
      </div>
    </div>
  );
}
